
import Vue from 'vue';

export default Vue.extend({
	name: 'AppInput',

	props: {
		description: String,
		error: String,
		errorMessages: { type: Object, default() { return {} } },
		hideLabel: Boolean,
		id: String,
		label: String,
		required: Boolean,
		vuelidate: { type: Object, default() { return {} } },
	},

	computed: {
		errorKeys(): string[] {
			return Object.keys(this.errorMessages);
		},

		hasError(): boolean {
			return (this.vuelidate.$error && this.vuelidate.$dirty) || !!this.error;
		},

		vuelidateError(): string | undefined {
			return this.vuelidateErrors[0];
		},

		vuelidateErrors(): string[] {
			if (!this.vuelidate.$error || !this.vuelidate.$dirty) {
				return [];
			}

			return this.errorKeys
				.filter((key: string) => this.vuelidate[key] === false)
				.map((key: string) => this.errorMessages[key] || '');
		},
	},
});
